import React from 'react';
import { Check, Award } from 'lucide-react';
import { Button } from '../components/ui/button';
import { BOOKING_URL } from '../config/booking';
import { trainers } from '../mockData';

const PersonalTraining = () => {
  const benefits = [
    'Individuelle Trainingspläne auf Ihre Ziele abgestimmt',
    'Zertifizierte Personal Trainer mit langjähriger Erfahrung',
    'Regelmäßige Fortschrittskontrollen und Anpassungen',
    'Ernährungsberatung und Lifestyle-Coaching',
    'Flexible Terminplanung nach Ihren Bedürfnissen',
    'Motivation und Unterstützung auf jedem Schritt'
  ];

  return (
    <div className="bg-black min-h-screen pt-20">
      {/* Hero */}
      <section className="relative h-[70vh] flex items-center justify-center text-white">
        <div className="absolute inset-0">
          <img 
            src="/images/personal.jpg"
            alt="Personal Training"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/60" />
        </div>
        <div className="relative z-10 text-center px-6 max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-bold tracking-tight mb-6 uppercase">
            Personal Training
          </h1>
          <p className="text-xl text-white/90 mb-8">
            Präzisionsbasiertes 1:1 Training mit zertifizierten Coaches, die sich der Maximierung Ihres Potenzials widmen.
          </p>
          <Button asChild size="lg" className="bg-white text-black hover:bg-white/90 h-12 px-8">
            <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer">
              Erstberatung buchen
            </a>
          </Button>
        </div>
      </section>

      {/* Benefits */}
      <section className="bg-white py-24">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-4xl lg:text-5xl font-bold mb-8 text-black">
                Ihr persönlicher Weg zum Erfolg
              </h2>
              <p className="text-lg text-black/80 mb-8 leading-relaxed">
                Unsere zertifizierten Personal Trainer entwickeln maßgeschneiderte Trainingsprogramme, die auf Ihre individuellen Ziele, Ihren Fitnesslevel und Ihre Bedürfnisse abgestimmt sind.
              </p>
              <ul className="space-y-4">
                {benefits.map((benefit, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <Check className="w-6 h-6 text-black flex-shrink-0 mt-0.5" />
                    <span className="text-black/80">{benefit}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="relative aspect-square">
              <img 
                src="/images/personal-training.jpg"
                alt="Training"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Trainers */}
      {/* <section className="bg-black py-24">
        <div className="max-w-[1920px] mx-auto px-6 lg:px-12">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold mb-6 text-white">
              Unsere Trainer
            </h2>
            <p className="text-xl text-white/80 max-w-3xl mx-auto">
              Lernen Sie unser Team von Elite-Coaches kennen, die Sie auf Ihrer Fitnessreise begleiten.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {trainers.map((trainer) => (
              <div key={trainer.id} className="group relative overflow-hidden aspect-[3/4]">
                <img 
                  src={trainer.image}
                  alt={trainer.name}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                  <h3 className="text-xl font-bold mb-2">{trainer.name}</h3>
                  <p className="text-white/80 text-sm mb-1">{trainer.specialty}</p>
                  <div className="flex items-center gap-2 text-white/70">
                    <Award className="w-4 h-4" />
                    <span className="text-xs">{trainer.experience} Erfahrung</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Training Approach */}
      <section className="bg-white py-24">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold mb-6 text-black">
              Unser Ansatz
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                title: '1. Analyse',
                description: 'Umfassende Bewertung Ihres aktuellen Fitnessstands, Ihrer Ziele und gesundheitlichen Voraussetzungen.',
                image: '/images/tretmill.jpg'
              },
              {
                title: '2. Planung',
                description: 'Entwicklung eines individualisierten Trainingsplans mit klaren Meilensteinen und messbaren Zielen.',
                image: '/images/planung.jpg'
              },
              {
                title: '3. Umsetzung',
                description: 'Kontinuierliche Betreuung, Motivation und Anpassung Ihres Trainings für optimale Ergebnisse.',
                image: '/images/umsetzung.jpg'
              }
            ].map((step, index) => (
              <div key={index} className="bg-black/5 p-8">
                <div className="aspect-video mb-6 overflow-hidden">
                  <img 
                    src={step.image}
                    alt={step.title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <h3 className="text-2xl font-bold mb-4 text-black">{step.title}</h3>
                <p className="text-black/70 leading-relaxed">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-black text-white py-24">
        <div className="max-w-4xl mx-auto text-center px-6">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6">
            Starten Sie noch heute
          </h2>
          <p className="text-xl text-white/80 mb-8">
            Buchen Sie Ihre kostenlose Erstberatung und lernen Sie Ihren persönlichen Coach kennen.
          </p>
          <Button asChild size="lg" className="bg-white text-black hover:bg-white/90 h-12 px-8">
            <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer">
              Erstberatung vereinbaren
            </a>
          </Button>
        </div>
      </section>
    </div>
  );
};

export default PersonalTraining;
